export default __webpack_public_path__ + "static/250-24dc4cbbc52ef040c1553e0e98b432b7.gif";